import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';
import { accidentConfig } from './configByInsuranceType/accident';
import { belongingsConfig } from './configByInsuranceType/belongings';
import { billProtectionConfig } from './configByInsuranceType/bill-protection';
import { carConfig } from './configByInsuranceType/car';
import { flightConfig } from './configByInsuranceType/flight';
import { fundConfig } from './configByInsuranceType/fund';
import { healthConfig } from './configByInsuranceType/health';
import { legalConfig } from './configByInsuranceType/legal';
import { liabilityConfig } from './configByInsuranceType/liability';
import { liabilityBusinessConfig } from './configByInsuranceType/liabilityBusiness';
import { lifeConfig } from './configByInsuranceType/life';
import { paymentProtectionConfig } from './configByInsuranceType/payment-protection';
import { productConfig } from './configByInsuranceType/product';
import { propertyConfig } from './configByInsuranceType/property';
import { travelConfig } from './configByInsuranceType/travel';

export const insurances: InsuranceFeatureConfig = {
    defaultRoute: 'overview',
    showManageInsurance: false,
    relyOnWebAPIAlias: false,
    showCurrentCapitalValue: false,
    claims: claimsConfig.base,
    dashboard: dashboardConfig.base,
    funds: fundsConfig.base,
    modifications: modificationsConfig.base,
    servicing: servicingConfig.base,
    accident: accidentConfig.base,
    belongings: belongingsConfig.base,
    billProtection: billProtectionConfig.base,
    car: carConfig.base,
    flight: flightConfig.base,
    fund: fundConfig.base,
    health: healthConfig.base,
    legal: legalConfig.base,
    liability: liabilityConfig.base,
    liabilityBusiness: liabilityBusinessConfig.base,
    life: lifeConfig.base,
    paymentProtection: paymentProtectionConfig.base,
    product: productConfig.base,
    property: propertyConfig.base,
    travel: travelConfig.base,
};
